import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchHistories = createAction(ACTION.FETCH_HISTORIES.REQUEST, params => ({
    ...params,
    sort_by: (params && params.sort_by) || 'created_at',
    sort_direction: (params && params.sort_direction) || 'desc'
}));
